export const VNANDROIDSDK_SET_VERSION = 'VNANDROIDSDK_SET_VERSION'
export const VNANDROIDSDK_IS_KEYBOARD_ACTIVE = 'VNANDROIDSDK_IS_KEYBOARD_ACTIVE'
export const VN_CFD_WEB_VIEW_LOADED = 'VN_CFD_WEB_VIEW_LOADED'
